import React from "react";
import { Route, RouteProps } from "react-router-dom";
import AuthGate from "./AuthGate";
import FeatureGate from "./FeatureGate";
import { InternalUserRoles, Role } from "../../constants/roles";
import { PageForbidden } from "../../pages/status/PageForbidden";

interface ProtectedRouteProps extends RouteProps {
  restrictedToRoles?: Role[];
  featureFlag?: string;
  featureFlagBypassRoles?: Role[];
  fallback?: React.ReactNode;
}

const ProtectedRoute = ({
  restrictedToRoles = InternalUserRoles,
  featureFlag,
  featureFlagBypassRoles,
  fallback = <PageForbidden />,
  component: Component,
  ...rest
}: ProtectedRouteProps) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        Component ? (
          <AuthGate restrictedToRoles={restrictedToRoles} fallback={fallback}>
            {featureFlag ? (
              <FeatureGate
                flag={featureFlag}
                bypassRoles={featureFlagBypassRoles}
                fallback={fallback}>
                <Component {...props} />
              </FeatureGate>
            ) : (
              <Component {...props} />
            )}
          </AuthGate>
        ) : null
      }
    />
  );
};

export default ProtectedRoute;
